export enum Alias {
  OVERRIDE = 'gpt-5-mini', // if set, this will be the chosen model regardless of what the model picker says (see Provider.OVERRIDE when changing this)
  DEFAULT = 'gpt-5.1',
  NONE = '',
  Gemini10Pro = 'gemini-1.0-pro',
  Gemini15Flash = 'gemini-1.5-flash',
  Gemini15Pro = 'gemini-1.5-pro',
  Gpt4o = 'gpt-4o',
  Gpt41 = 'gpt-4.1',
  Gpt41Mini = 'gpt-4.1-mini',
  Gpt41Nano = 'gpt-4.1-nano',
  Gpt5 = 'gpt-5',
  Gpt5Mini = 'gpt-5-mini',
  Gpt5Nano = 'gpt-5-nano',
  Gpt51 = 'gpt-5.1',
  Claude3Haiku = 'claude-3-haiku',
  Claude3Sonnet = 'claude-3-sonnet',
  Claude35Sonnet = 'claude-3.5-sonnet',
  Mistral8x7b = 'mistral-8x7b',
  MistralMedium = 'mistral-medium',
  MistralLarge = 'mistral-large',
}


export const CurrentFastModels: Alias[] = [
  Alias.Claude3Haiku,
  Alias.Gemini15Flash,
  Alias.Mistral8x7b,
];

export const CurrentDeepModels: Alias[] = [
  Alias.Claude3Sonnet,
  Alias.Claude35Sonnet,
  Alias.Gemini10Pro,
  Alias.Gemini15Pro,
  Alias.Gpt4o,
  Alias.Gpt41,
  Alias.Gpt41Mini,
  Alias.Gpt41Nano,
  Alias.Gpt5,
  Alias.Gpt5Mini,
  Alias.Gpt5Nano,
  Alias.Gpt51,
  Alias.MistralMedium,
  Alias.MistralLarge,
];

export const CurrentModels: Alias[] = [
  ...CurrentFastModels,
  ...CurrentDeepModels,
].sort();


export function isDeepModel(alias: Alias): boolean {
  return CurrentDeepModels.includes(alias);
}


/**
 * This is not exported because it contains aliases that are no longer
 * supported. For a complete list of current models, use CurrentModels.
 *
 * @see CurrentModels
 */
const AliasNameMap: { [k in Alias]: string } = {
  [Alias.NONE]: 'None',
  [Alias.Claude3Haiku]: 'Claude 3 Haiku',
  [Alias.Claude3Sonnet]: 'Claude 3 Sonnet',
  [Alias.Claude35Sonnet]: 'Claude 3.5 Sonnet',
  [Alias.Gemini10Pro]: 'Gemini 1.0 Pro',
  [Alias.Gemini15Flash]: 'Gemini 1.5 Flash',
  [Alias.Gemini15Pro]: 'Gemini 1.5 Pro',
  [Alias.Gpt4o]: 'GPT-4o',
  [Alias.Gpt41]: 'GPT-4.1',
  [Alias.Gpt41Mini]: 'GPT-4.1 mini',
  [Alias.Gpt41Nano]: 'GPT-4.1 nano',
  [Alias.Gpt5]: 'GPT-5',
  [Alias.Gpt5Mini]: 'GPT-5 mini',
  [Alias.Gpt5Nano]: 'GPT-5 nano',
  [Alias.Gpt51]: 'GPT-5.1',
  [Alias.Mistral8x7b]: 'Mixtral 8x7B',
  [Alias.MistralMedium]: 'Mistral Medium',
  [Alias.MistralLarge]: 'Mistral Large',
};


export enum Provider {
  OVERRIDE = 'openai',  // if set, this will be the chosen provider regardless of what the model picker says (see Alias.OVERRIDE when changing this)
  DEFAULT = 'openai',
  MANUAL = 'manual',
  NONE = '',
  Anthropic = 'anthropic',
  Google = 'google',
  Mistral = 'mistral',
  OpenAi = 'openai',
}


const AliasProviderMap: { [k in Alias]: Provider } = {
  [Alias.NONE]: Provider.NONE,
  [Alias.Claude3Haiku]: Provider.Anthropic,
  [Alias.Claude3Sonnet]: Provider.Anthropic,
  [Alias.Claude35Sonnet]: Provider.Anthropic,
  [Alias.Gemini10Pro]: Provider.Google,
  [Alias.Gemini15Flash]: Provider.Google,
  [Alias.Gemini15Pro]: Provider.Google,
  [Alias.Gpt4o]: Provider.OpenAi,
  [Alias.Gpt41]: Provider.OpenAi,
  [Alias.Gpt41Mini]: Provider.OpenAi,
  [Alias.Gpt41Nano]: Provider.OpenAi,
  [Alias.Gpt5]: Provider.OpenAi,
  [Alias.Gpt5Mini]: Provider.OpenAi,
  [Alias.Gpt5Nano]: Provider.OpenAi,
  [Alias.Gpt51]: Provider.OpenAi,
  [Alias.Mistral8x7b]: Provider.Mistral,
  [Alias.MistralMedium]: Provider.Mistral,
  [Alias.MistralLarge]: Provider.Mistral,
};


export const getAliasName = (alias: Alias): string => {
  const aliasName = AliasNameMap[alias];
  return aliasName ? aliasName : Alias.NONE;
};


export const getAliasProvider = (alias: Alias): Provider => {
  const aliasProvider = AliasProviderMap[alias];
  return aliasProvider ? aliasProvider : Provider.NONE;
};

